// This is an overview of all the limits that we are using in our apps

export const TOTAL_CREATORS = 'TOTAL_CREATORS';
export const TOTAL_ASSETS = 'TOTAL_ASSETS';
export const TOTAL_VIDEOS = 'TOTAL_VIDEOS';
export const VIDEO_DURATION = 'VIDEO_DURATION';

export const CONTENT_LIMIT_APPROACHING_BUFFER = 5;
export const CREATOR_LITE_LIMIT_APPROACHING_BUFFER = 5;

export const LIMITS = {
  STARTER_FREE: {
    VIDEO_DURATION: 300,
    CREATOR_LITE_MEMBER_LIMIT: 50,
  },
  BUSINESS: {
    CREATOR_LITE_MEMBER_LIMIT: 50,
  },
  EDUCATION: {
    TOTAL_CREATORS: 1,
  },
};

export const MEMBER_VIDEO_LIMIT = Number(
  process.env.CREATOR_LITE_TOTAL_VIDEOS || 25
);

export const MEMBER_LIMITS = {
  STARTER_FREE: {
    ADMIN: {
      TOTAL_VIDEOS: MEMBER_VIDEO_LIMIT,
    },
  },
  CREATOR_LITE: {
    TOTAL_VIDEOS: MEMBER_VIDEO_LIMIT,
    VIDEO_DURATION: 300,
  },
};

export const LIMIT_OVERRIDES = {
  TOTAL_VIDEOS,
};

export const LIMIT_OVERRIDE_TYPES = {
  SET: 'SET',
  INCREMENT: 'INCREMENT',
};
